<div class="lc-setup-dashboard">
  <div *ngIf="loading" class="lc-setup-loading">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    Chargement de la configuration…
  </div>

  <div *ngIf="!loading && errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

  <ng-container *ngIf="!loading && overview && !errorMessage">
    <!-- État vide : première visite -->
    <div *ngIf="overview.isEmpty" class="lc-setup-empty card">
      <div class="card-body text-center py-5">
        <div class="lc-setup-empty-icon mb-3">
          <i data-feather="settings" [size]="48"></i>
        </div>
        <h3 class="mb-2">Rien n'est configuré</h3>
        <p class="text-muted mb-4 mx-auto lc-setup-empty-text">
          Pour utiliser le logiciel de caisse, configurez votre premier point de vente :
          établissement, entrepôt et caisse.
        </p>
        <button type="button" class="btn btn-primary btn-lg" (click)="startWizard()">
          Configurer mon premier point de vente
        </button>
      </div>
    </div>

    <!-- Tableau de bord configuré -->
    <ng-container *ngIf="!overview.isEmpty">
      <div class="lc-setup-header d-flex flex-wrap align-items-center justify-content-between mb-2">
        <div>
          <h3 class="mb-25">Configuration logiciel de caisse</h3>
          <p class="text-muted mb-0">
            {{ overview.completedSteps }}/{{ overview.totalSteps }} étapes complétées
          </p>
        </div>
        <button type="button" class="btn btn-outline-primary" (click)="addMagasin()">
          + Ajouter un magasin
        </button>
      </div>

      <div class="progress mb-3 lc-setup-progress">
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="overview.progressPercent"
          [attr.aria-valuenow]="overview.progressPercent"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>

      <div class="row">
        <div class="col-lg-5 mb-2">
          <div class="card h-100">
            <div class="card-header">
              <h4 class="card-title mb-0">Checklist</h4>
            </div>
            <ul class="list-group list-group-flush lc-setup-checklist">
              <li
                *ngFor="let item of overview.checks"
                class="list-group-item d-flex align-items-start lc-setup-check-item"
                [class.lc-done]="item.done"
                (click)="openCheck(item)"
              >
                <span class="lc-check-icon mr-1">
                  <i
                    [attr.data-feather]="item.done ? 'check-circle' : 'circle'"
                    [size]="20"
                    [class.text-primary]="item.done"
                  ></i>
                </span>
                <div class="flex-grow-1">
                  <div class="font-weight-bold">{{ item.label }}</div>
                  <small class="text-muted d-block">{{ item.description }}</small>
                  <small *ngIf="item.count > 0" class="text-primary">{{ item.count }} enregistré(s)</small>
                </div>
                <i data-feather="chevron-right" [size]="18" class="text-muted"></i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-7 mb-2">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">Structure</h4>
              <button type="button" class="btn btn-sm btn-icon btn-outline-secondary" (click)="reload()" title="Actualiser">
                <i data-feather="refresh-cw" [size]="16"></i>
              </button>
            </div>
            <div class="card-body lc-setup-tree-body">
              <ng-container *ngIf="overview.tree.length; else noTree">
                <ng-container
                  *ngTemplateOutlet="treeTpl; context: { nodes: overview.tree, depth: 0 }"
                ></ng-container>
              </ng-container>
              <ng-template #noTree>
                <p class="text-muted mb-0">Aucune structure à afficher.</p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="overview.coreComplete && overview.completedSteps === overview.totalSteps" class="alert alert-primary mt-2 mb-0">
        <i data-feather="check" [size]="18" class="mr-50"></i>
        Votre configuration est complète. Vous pouvez utiliser le menu pour gérer vos magasins au quotidien.
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #treeTpl let-nodes="nodes" let-depth="depth">
  <ul class="lc-tree-list" [class.lc-tree-root]="depth === 0">
    <li *ngFor="let node of nodes" class="lc-tree-node" [style.paddingLeft.px]="depth * 16">
      <div class="lc-tree-row">
        <i [attr.data-feather]="nodeIcon(node.type)" [size]="16" class="mr-50"></i>
        <span class="lc-tree-label">{{ node.label }}</span>
        <small *ngIf="node.meta" class="text-muted ml-50">({{ node.meta }})</small>
      </div>
      <ng-container *ngIf="node.children?.length">
        <ng-container
          *ngTemplateOutlet="treeTpl; context: { nodes: node.children, depth: depth + 1 }"
        ></ng-container>
      </ng-container>
    </li>
  </ul>
</ng-template>
